import { render, staticRenderFns } from "./HubDetails.vue?vue&type=template&id=0e1ad214"
import script from "./HubDetails.vue?vue&type=script&lang=js"
export * from "./HubDetails.vue?vue&type=script&lang=js"
import style0 from "./HubDetails.vue?vue&type=style&index=0&id=0e1ad214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports